import { concat, get, isArray } from 'lodash';
import React from 'react';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS } from 'src/lib/constants/componentsPath';
import { TreeNodeType } from 'src/lib/types/types';

// import Schemas
import MASchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import OptionaleAnlagenMA from './content/OptionaleAnlagenMA';
import PflichtAnlagenMA, { getFormStrucPflichtAnlagenMA } from './content/PflichtanlagenMA';
import SonstigeAnlagenMA, { getFormStrucSonstigeAnlagenMA } from './content/SonstigeAnlagenMA';
const P = MASchema.attributes;

export const TreeStructureAnlagenMA = (application: any) => {
	const foerderprogramm = get(application, P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	const paths = FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS;

	const hasValidAnlagen = (anlagen: any[]) => {
		if (isArray(anlagen) && anlagen.length > 0) {
			return anlagen.some((ele) => get(ele, 'Bezeichnung_Des_Dokuments', '').trim() !== '');
		} else {
			return false;
		}
	};

	let treeNodes: TreeNodeType[] = [];

	const pflichtAnlagen = get(application, P.Anlagen_Erforderliche_Anlagen.path, []);
	const optionaleAnlagen = get(application, P.Anlagen_Optionale_Anlagen.path, []);

	if (hasValidAnlagen(pflichtAnlagen) || hasValidAnlagen(optionaleAnlagen)) {
		treeNodes = [
			{
				label: 'Anlagen',
				content: <ApplicationHeading title={'Anlagen'} />,
				children: [
					...(hasValidAnlagen(pflichtAnlagen) ?
						[
							{
								label: get(foerderprogramm, paths.PflichtAnlageTitel, 'Pflichtanlagen'),
								content: <PflichtAnlagenMA />,
								formStruc: getFormStrucPflichtAnlagenMA(application),
							},
						]
					:	[]),
					...(hasValidAnlagen(optionaleAnlagen) ?
						[
							{
								label: get(foerderprogramm, paths.OptionaleAnlageTitel, 'Optionale Anlagen'),
								content: <OptionaleAnlagenMA />,
							},
						]
					:	[]),
					{
						label: get(foerderprogramm, paths.SontigeAnlageTitel, 'Sonstige Anlagen'),
						content: <SonstigeAnlagenMA />,
						formStruc: getFormStrucSonstigeAnlagenMA(application),
					},
				],
			},
		];
	} else {
		treeNodes = [
			{
				label: 'Anlagen',
				content: <SonstigeAnlagenMA />,
				formStruc: concat(getFormStrucPflichtAnlagenMA(application), getFormStrucSonstigeAnlagenMA(application)),
			},
		];
	}

	return treeNodes;
};
